import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readOrderTypeSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";


/**
 * 수주 유형
 * @param props
 * @returns
 */
export const useReadOrderTypeSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readOrderTypeSelect"],
        queryFn: async () => readOrderTypeSelectBoxApi(),
        select: (res) => res?.result,
        // staleTime: 6000 * 10,
    });
    return {data};
};
